<details class="expired-quotes" data-testid="expired-quotes-accordion">
  <summary class="expired-quotes__summary">
    <svg
      class="expired-quotes__chevron"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z"
        fill="#333333"
      />
    </svg>
    Expired Quotes
    <span class="expired-quotes__count" data-testid="expired-quotes-count"
      >({{ expiredCount() }})</span
    >
  </summary>

  <div class="expired-quotes__list">
    @for (
      estimate of estimates();
      track estimate.vendorId ?? estimate.estimationsId ?? $index
    ) {
      <article
        class="expired-quotes__card"
        [attr.data-testid]="
          'expired-quote-entry-' +
          (estimate.vendorId ?? estimate.estimationsId ?? $index)
        "
      >
        <div class="expired-quotes__card-left">
          <span
            class="expired-quotes__vendor-name"
            data-testid="expired-quote-vendor-name"
            >{{ estimate.name ?? "Unknown Vendor" }}</span
          >
          <span class="expired-quotes__status-row">
            <span
              class="expired-quotes__status"
              data-testid="expired-quote-status"
              >Cancelled</span
            >
            <span
              class="expired-quotes__supporting-text"
              data-testid="expired-quote-supporting-text"
              >Quote expired.</span
            >
          </span>
        </div>
        <span
          class="expired-quotes__expiration-date"
          data-testid="expired-quote-expiration-date"
          >Quote expired on:
          <span>{{ estimate.expirationDateVendor | date: "dd/MMM/yyyy" }}</span></span
        >
      </article>
    }
  </div>
</details>
